// const baseURL = "http://38.242.206.181/api/v1" //dev

//const baseURL = "http://84.46.251.183/api/v1" //live
//const baseURL = "https://engage-backend.rwndynamics.com/api/v1" //production
const baseURL = "https://main-enagage.rwndynamics.com/api/v1" //production


export { baseURL }
